export class EmpresaCscRequest {
  idCsc: string;
  tokenCsc: string;
}